var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.single)?_c('fieldset',{staticClass:"panel"},[_c('legend',{domProps:{"textContent":_vm._s(_vm.title)}}),_c('div',{staticClass:"inner"},[_vm._t("default")],2)]):_c('div',{staticClass:"inner"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }